// import AddIcon from '@mui/icons-material/Add'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const ParentCell = ({ row }) => {
  return row.parent_id ? (
    <span spacing={1}>
      <Link to={`/patient/${row.parent_id}/result`}>{row.parent_name}</Link>
    </span>
  ) : (
    <span spacing={1}>{row.parent_name}</span>
  )
}

ParentCell.propTypes = {
  row: PropTypes.object,
}

export default ParentCell
